import React, { Component } from 'react';
import RefundTicketModal from './RefundTicketModal';
import { FORMAT_NUMBER, CURRENCY, SYMBOL, _ROUND } from '../libs/utils/Const';
import { ValidationModal } from '../components/index';
import { PdfViewer } from "./index";
import '../css/formats.css';
import RefundOfPaymentsModal from './RefundOfPaymentsModal';
import { ToolTip } from '../components/index';
import { ToolTips } from '../libs/utils/Const';
const tips = ToolTips.CounterTips;
class RefundModal extends Component {

    shouldComponentUpdate = (nextProps) => {
        if (this.props !== nextProps) {
            return true;
        }
    }

    RefreshModel = (ordersSearchModel) => {
        const { SalesTools } = this.props;
        SalesTools.RefreshSearchOrdersModel(ordersSearchModel);
    }

    OnchangeCardCode = (value) => {
        const { SalesTools } = this.props;
        SalesTools.ordersSearchModel.CardCode = value;
        this.RefreshModel(SalesTools.ordersSearchModel);
    }

    OnchangeDocNum = (value) => {
        const { SalesTools } = this.props;
        SalesTools.ordersSearchModel.DocNum = value;
        this.RefreshModel(SalesTools.ordersSearchModel);
    }

    TaxTotal = (line) => {
        return _ROUND(parseFloat((line.Price * line.Quantity).toFixed(2)) * (line.VatPrcnt / 100))
    }

    IsInteger(num) {
        if (num % 1 === 0) {
            return true
        } else {
            return false
        }
    }

    selectTip = () => {
        const { action } = this.props;
        const { Refund, Cancel, CancelSale } = tips;
    
        switch (action) {
            case 'refund':
                return Refund;
            case 'cancel':
                return Cancel;
            case 'cancelSale':
                return CancelSale;
            default:
                return [];
        }
    }

    render() {
        const {
            newOrderModel,
            pedido,
            ChangePedido,
            SearchSale,
            ChangeQuantityRefund,
            ChangeComments,
            checkbox,
            CloseRefundModal,
            showrefund,
            newOrderModelCopia,
            CloseBillModal,
            SalesTools,
            user,
            action,
            ChangeActionSale,
            Print,
            CloseOpenRefundOfPaymentsModal,
            CheckIfHaveSelectedReturnItems,
            ShowRefundOfPaymentsModal,
            ConsultarEstatusCFDI,
            MailTools,
            isCancel,
            isValidCFDI,
            CancelCFDI,
            createdFromReserve,
            ItsCreditInvoice,
            ShowFormatToPrint,
            OpenMailModal,
            printhide,
            itsCancelCFDIAvailable,
            ValidateCloseDocument,
            ItsReturnBill,
            ItsReserveInvoice,
            relatedDocs,
        } = this.props;
        return (
            <div>
                <div className="modal fade  modal-fullscreen" id="refundModal" data-backdrop="false" data-keyboard="false" tabIndex="-1" aria-labelledby="refundModalLabel" aria-hidden="true" >
                    <div className="modal-dialog" >
                        <div className="modal-content">
                            <div className="modal-header" style={{ background: "#343a40" }}>
                                <img src={require('../images/logocounter.png')} className="image" alt="COUNTER ONE" />
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close" style={{ color: "white" }} onClick={() => CloseRefundModal()}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="row ml-3 mt-3">
                                    <h4 className="modal-title ml-4" id="refundModalLabel">Devolución y/o Cancelaciones</h4>
                                </div>
                                <div className="container-fluid mt-3">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row m-3">
                                                <div className="col-4">
                                                    <div className="input-group mb-3">
                                                        <div className="input-group-prepend">
                                                            <span className="input-group-text" id="basic-addon1">
                                                                <strong>Buscar documento</strong>
                                                                <ToolTip tips={tips.SearchRefund} position={'up'}/>
                                                            </span>
                                                        </div>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Folio"
                                                            onKeyPress={(ev) => {
                                                                if (ev.key === 'Enter') {
                                                                    SearchSale();
                                                                }
                                                            }}
                                                            onChange={ChangePedido}
                                                            value={pedido ? pedido : ''}

                                                        />
                                                        <div className="input-group-append">
                                                            <button type="button" className="input-group-text" style={{ backgroundColor: 'transparent', color: '#a1a9b1' }} onClick={() => SearchSale()}>
                                                                <i className="fas fa-search" />
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='col-8'>
                                                    {action === 'cancel' && createdFromReserve &&
                                                        <></>
                                                        // <button
                                                        //     type="button"
                                                        //     className="btn btn-danger ml-2"
                                                        //     onClick={() => CancelDocument()}
                                                        // >
                                                        //     Cancelar SAP
                                                        // </button>
                                                    }

                                                </div>

                                                <div className="col-md-3">
                                                    <div className="input-group">
                                                        <div className="input-group-prepend">
                                                            <span className="input-group-text"><strong>Cliente</strong></span>
                                                        </div>
                                                        <input type="text" className="form-control" disabled value={newOrderModel.CardCode} />
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="input-group">
                                                        <div className="input-group-prepend">
                                                            <span className="input-group-text"><strong>Nombre</strong></span>
                                                        </div>
                                                        <input type="text" className="form-control" disabled value={newOrderModel.CardName} />
                                                    </div>
                                                </div>
                                                <div className='col-6 text-right'>
                                                    <div className="input-group">
                                                        <div className="input-group-prepend">
                                                            <span className="input-group-text" id="basic-addon1">
                                                                <strong for="inputGroupSelect01">Operación:</strong>
                                                                {this.selectTip().length > 0 && 
                                                                    <ToolTip tips={this.selectTip()} position={'up'} />
                                                                }
                                                            </span>
                                                        </div>
                                                        <select className="custom-select" id="inputGroupSelect04" value={action} onChange={(event) => { ChangeActionSale(event.target.value) }}>
                                                            <option selected value="">Elige una operación</option>
                                                            <option value="refund">Devolución</option>
                                                            {/* <option value="invoice">Facturación</option> */}
                                                            {itsCancelCFDIAvailable && relatedDocs.length === 0 ?
                                                                <option value="cancel">Cancelación CFDI</option>
                                                                :
                                                                relatedDocs.length === 0 ? 
                                                                <option value="cancelSale">Cancelar venta</option>
                                                                :
                                                                <></>
                                                            }


                                                        </select>
                                                        <div className="input-group-append">
                                                            {action === '' &&
                                                                <button type="button" className="btn btn-outline-secondary ml-2" disabled >Realizar</button>
                                                            }
                                                            {action === 'refund' &&
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-outline-primary ml-2"
                                                                    onClick={() => CheckIfHaveSelectedReturnItems(() => CloseOpenRefundOfPaymentsModal(true), 'Seleccione uno o varios artículos a devolver')}
                                                                >
                                                                    Devolver
                                                                </button>
                                                            }
                                                            {action === 'invoice' &&
                                                                <button type="button" className="btn btn-outline-primary ml-2" data-toggle="modal" onClick={() => SalesTools.SendDocsToPdfViewer()}>Facturar</button>
                                                            }

                                                            {action === 'cancel' && isValidCFDI &&
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-danger ml-2"
                                                                    data-toggle="modal"
                                                                    onClick={() => CancelCFDI(true)}
                                                                >
                                                                    Cancelar CFDI
                                                                </button>
                                                            }

                                                            {action === 'cancel' && isCancel &&
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-outline-danger ml-2"
                                                                    data-toggle="modal"
                                                                    onClick={() => CloseOpenRefundOfPaymentsModal(true)}
                                                                >
                                                                    Cancelar Venta
                                                                </button>
                                                            }

                                                            {action === 'cancel' && !isValidCFDI && !isCancel &&
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-info text-white"
                                                                    onClick={() => ConsultarEstatusCFDI(true)}
                                                                >
                                                                    Consultar estatus
                                                                </button>
                                                            }

                                                            {action === 'cancelSale' && !itsCancelCFDIAvailable &&
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-outline-danger ml-2"
                                                                    data-toggle="modal"
                                                                    onClick={() => ValidateCloseDocument()}
                                                                >
                                                                    Cancelar documento
                                                                </button>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {(action === 'refund' || action === 'cancelSale') &&
                                                <div className="row m-3">
                                                    <div className="col-6">
                                                        <div className="input-group mb-3">
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text"><strong>Comentarios</strong></span>
                                                            </div>
                                                            <textarea
                                                                type="text"
                                                                className="form-control"
                                                                aria-label="With textarea"
                                                                value={newOrderModel.Comments}
                                                                onChange={(event) => { ChangeComments(0, event) }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-3"> </div>
                                                    <div className="col-3">
                                                        {!!ItsCreditInvoice && ItsCreditInvoice &&
                                                            <>
                                                                <div className="input-group">
                                                                    <div className="input-group-prepend">
                                                                        <span className="input-group-text">
                                                                            <strong>Abonado: </strong>
                                                                            <ToolTip tips={[tips.CreditInvoice[0]]} position={'up'}/>
                                                                        </span>
                                                                    </div>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        disabled
                                                                        value={CURRENCY + ' ' + FORMAT_NUMBER.new(newOrderModel.AbonadoTotal) || 0} />
                                                                </div>


                                                                <div className="input-group">
                                                                    <div className="input-group-prepend">
                                                                        <span className="input-group-text">
                                                                            <strong>Saldo pendiente: </strong>
                                                                            <ToolTip tips={[tips.CreditInvoice[1]]} position={'up'}/>
                                                                        </span>
                                                                    </div>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        disabled
                                                                        value={CURRENCY + ' ' + FORMAT_NUMBER.new(newOrderModel.OutstandingBalance) || 0}
                                                                    />
                                                                </div>

                                                            </>
                                                        }

                                                    </div>
                                                </div>
                                            }

                                            <div className='card scrollTableRefound m-4' style={{ maxHeight: "435px" }}>
                                                <table className="table table-striped table-hover">
                                                    <thead>
                                                        {(action === '' || action === 'invoice' || action === 'cancel' || action === 'cancelSale') &&
                                                            <tr>
                                                                <th className="text-center" scope="col">

                                                                </th>
                                                                <th className="text-center" scope="col">
                                                                    Código
                                                                </th>
                                                                <th className="col-6 text-center" scope="col">
                                                                    Nombre
                                                                </th>
                                                                <th className=" text-center" scope="col">
                                                                    Cantidad
                                                                </th>
                                                                <th className="text-center" scope="col">
                                                                    Estatus
                                                                </th>
                                                                <th className="text-center" scope="col">
                                                                    Precio U.
                                                                </th>
                                                                {ItsReturnBill &&
                                                                    <>
                                                                        <th className=" text-center" scope="col">
                                                                            Descuento
                                                                        </th>
                                                                        <th className=" text-center" scope="col">
                                                                            SubTotal
                                                                        </th>
                                                                    </>
                                                                }
                                                                <th className=" text-center" scope="col">
                                                                    Total linea
                                                                </th>
                                                            </tr>
                                                        }
                                                        {action === 'refund' &&
                                                            <tr>
                                                                <th className="text-center">
                                                                    <input
                                                                        type="checkbox"
                                                                        style={{ minWidth: '100%', width: '15px', height: '15px' }}
                                                                        id="CheckAll"
                                                                        onChange={(event) => checkbox.selectAll(event.target.checked)}
                                                                    />
                                                                </th>
                                                                <th className="text-center">
                                                                    Cantidad
                                                                    {ItsReserveInvoice &&
                                                                        <span className="d-inline-block font-weight-normal">
                                                                            <ToolTip tips={[tips.ReserveInvoice[0]]} position={'down'} />
                                                                        </span>  
                                                                    } 
                                                                </th>
                                                                <th className="text-center">
                                                                    Estatus
                                                                    {ItsReserveInvoice &&
                                                                        <span className="d-inline-block font-weight-normal">
                                                                            <ToolTip tips={[tips.ReserveInvoice[1]]} position={'down'} />
                                                                        </span>  
                                                                    } 
                                                                </th>
                                                                <th className="text-center">Código</th>
                                                                <th className="text-center">Descripción</th>
                                                                <th className="text-center" scope="col">Precio U.</th>
                                                                {ItsReturnBill &&
                                                                    <>
                                                                        <th className="text-center" scope="col">Descuento</th>
                                                                        <th className="text-center" scope="col">SubTotal</th>
                                                                    </>
                                                                }


                                                                <th className="text-center" scope="col">Total linea</th>

                                                            </tr>
                                                        }
                                                    </thead>
                                                    <tbody>
                                                        {/* invoice - return */}
                                                        {newOrderModel.Items && newOrderModel.Items.length > 0 && (action === '' || action === 'invoice' || action === 'cancel' || action === 'cancelSale') &&
                                                            newOrderModel.Items.map((line, index) => {
                                                                return (
                                                                    <tr key={index}>
                                                                        <td className="text-center">
                                                                            <input
                                                                                type="checkbox"
                                                                                style={{ minWidth: '100%', width: '15px', height: '15px' }}
                                                                                disabled={true}
                                                                                checked={true}
                                                                            />
                                                                        </td>
                                                                        <td className="text-center">
                                                                            <strong>{line.ItemCode ?? ''}</strong>
                                                                        </td>
                                                                        <td className="text-center">{line.Description ? line.Description : line.ItemName ? line.ItemName : ''}</td>
                                                                        <td className="text-center">
                                                                            <input
                                                                                className="text-center"
                                                                                type="text"
                                                                                disabled={true}
                                                                                onChange={(event) => { ChangeQuantityRefund(index, line, event) }}
                                                                                value={Number(line.OpenQty).toFixed(4) || ""}
                                                                            />
                                                                        </td>
                                                                        <td className="text-center">{line.InvntSttus ? 'ENTREGADO' : 'PENDIENTE DE ENTREGA'}</td>
                                                                        <td className="text-center">{CURRENCY + ' ' + FORMAT_NUMBER.new(Number(line.Price ?? 0))}</td>
                                                                        {ItsReturnBill &&
                                                                            <>
                                                                                <td className="text-center">{FORMAT_NUMBER.new(Number(line.Discount) ?? '') + ' %'}</td>
                                                                                <td className="text-center">{CURRENCY + ' ' + FORMAT_NUMBER.new(Number(line.Total))}</td>

                                                                            </>
                                                                        }
                                                                        {ItsReturnBill ?
                                                                            <td className="text-center">{CURRENCY + ' ' + FORMAT_NUMBER.new(Number(line.Total) + Number(line.VatSum))}</td>
                                                                            :
                                                                            <td className="text-center">{CURRENCY + ' ' + FORMAT_NUMBER.new((Number(line.OpenQty) * Number(line.Price)) * ((100 + Number(line.TaxRate)) / 100))}</td>
                                                                        }
                                                                    </tr>
                                                                );
                                                            })
                                                        }
                                                        {/* return docs */}
                                                        {!!newOrderModel.Items && action === 'refund' && newOrderModel.Items.map((doc, index) => {

                                                            return (
                                                                <tr key={index} >
                                                                    <td className="text-center">
                                                                        <input
                                                                            type="checkbox"
                                                                            style={{ minWidth: '100%', width: '15px', height: '15px' }}
                                                                            id="CheckAll"
                                                                            // disabled={parseInt(doc.OpenQty) === 0 ? true : false}
                                                                            checked={!!checkbox.data.get(index)}
                                                                            onChange={() => checkbox.selectOne(index)}
                                                                        />
                                                                    </td>
                                                                    <td className="text-center">

                                                                        {this.IsInteger(Number(doc.OpenQty).toFixed(4))
                                                                            ?
                                                                            <strong>{parseInt(doc.OpenQty ?? 0)}{" / "}
                                                                                <input
                                                                                    type="number"
                                                                                    min={0}
                                                                                    className="text-left input-cantidad"
                                                                                    max={parseInt(doc.OpenQty)}
                                                                                    onChange={(event) => { ChangeQuantityRefund(index, doc, event) }}
                                                                                    value={doc.newQuantity}
                                                                                />
                                                                            </strong>
                                                                            :
                                                                            <>
                                                                                <strong>{Number(doc.OpenQty ?? 0).toFixed(4)}{" / "}</strong>
                                                                                <input
                                                                                    type="number"
                                                                                    className="text-left input-cantidadDeci"
                                                                                    onChange={(event) => { ChangeQuantityRefund(index, doc, event) }}
                                                                                    value={doc.newQuantity ?? ''}
                                                                                />
                                                                            </>

                                                                        }
                                                                    </td>
                                                                    <td className="text-center">{doc.InvntSttus ? 'ENTREGADO' : 'PENDIENTE DE ENTREGA'}</td>
                                                                    <td className="text-center">{doc.ItemCode}</td>
                                                                    <td className="text-left">{doc.Description}</td>
                                                                    <td className="text-center">{CURRENCY + ' ' + FORMAT_NUMBER.new(Number(doc.Price ?? 0))}</td>
                                                                    {ItsReturnBill &&
                                                                        <>
                                                                            <td className="text-center">{FORMAT_NUMBER.new(Number(doc.Discount) ?? '') + ' %'}</td>
                                                                            <td className="text-center">{CURRENCY + ' ' + FORMAT_NUMBER.new(Number(doc.Total))}</td>

                                                                        </>
                                                                    }
                                                                    {ItsReturnBill ?
                                                                        <td className="text-center">{CURRENCY + ' ' + FORMAT_NUMBER.new(Number(doc.Total) + Number(doc.VatSum))}</td>

                                                                        :
                                                                        <td className="text-center">{CURRENCY + ' ' + FORMAT_NUMBER.new((Number(doc.OpenQty) * Number(doc.Price)) * ((100 + Number(doc.TaxRate)) / 100))}</td>
                                                                    }

                                                                </tr>
                                                            );
                                                        })}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mt-1">
                                        <div className="col-md-12">
                                            <div className="row m-3">
                                                <div className="col-9"></div>
                                                <div className="col-3 text-right">
                                                    <div className="input-group">
                                                        <div className="input-group-prepend">
                                                            <span className="input-group-text"><strong>Subtotal</strong></span>
                                                        </div>
                                                        <input type="text" className="form-control text-right" disabled placeholder={(Number(newOrderModel.DocTotal || 0) - Number(newOrderModel.VatSum || 0)).toFixed(2)} />
                                                    </div>
                                                    <div className="input-group mt-3">
                                                        <div className="input-group-prepend">
                                                            <span className="input-group-text"><strong>IVA</strong></span>
                                                        </div>

                                                        <input type="text" className="form-control text-right" disabled placeholder={Number(newOrderModel.VatSum || 0).toFixed(2)} />




                                                    </div>
                                                    <div className="input-group mt-3">
                                                        <div className="input-group-prepend">
                                                            <span className="input-group-text"><strong>Total</strong></span>
                                                        </div>
                                                        <input type="text" className="form-control text-right" disabled placeholder={Number(newOrderModel.DocTotal || 0).toFixed(2)} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                {/* <button type="button" className="btn btn-secondary" data-toggle="modal" data-target="#refundOfPaymentsModal">NO PRESIONAR</button> */}
                                <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={() => CloseRefundModal()}>Cancelar</button>
                            </div>
                        </div>
                    </div>
                </div>

                {
                    showrefund && (
                        <RefundTicketModal
                            newOrderModel={newOrderModelCopia}
                            CloseBillModal={CloseBillModal}
                            Print={Print}
                            _user={user}
                        />
                    )
                }

                <ValidationModal
                    idValidation="vmCloseIV"
                    message="SELECCIONO UNA FACTURA, SE GENERARA UNA NOTA DE CRÉDITO ¿DESEA CONTINUAR?"
                    idModalOrigin="#salesModal"
                    idModalDestiny="#salesModal"
                    eventOnclick={SalesTools.CloseDocument}
                />
                <ValidationModal
                    idValidation="vmCloseDL"
                    message="SE CERRARA LA ENTREGA Y SE GENERARA UNA DEVOLUCIÓN ¿DESEA CONTINUAR?"
                    idModalOrigin="#salesModal"
                    idModalDestiny="#salesModal"
                    eventOnclick={SalesTools.CloseDocument}
                // eventOnclick2={()=>SalesTools.CloseModalByID('vmCloseDL')}
                />

                {
                    SalesTools.showPDFViewer &&
                    <PdfViewer
                        DocsToPrint={SalesTools.docsToPrint}
                        TypeDoc={'OINV'}
                        EnableEditButton={false}
                        Editable={SalesTools.editableMode}
                        ChangeEditableMode={SalesTools.ChangeEditableMode}
                        EditableDocModel={SalesTools.EditableDocModel}
                        RefreshDocModel={SalesTools.RefreshDocModel}
                        SaveChanges={SalesTools.SaveChangesOrderInvoice}
                        UploadDoc={SalesTools.UploadInvoice}
                        EditParam1={false}
                        ShowPDFViewer={SalesTools.ShowPDFViewer}
                        user={user}
                        Counter={true}
                        MailTools={MailTools}
                        OpenMailModal={OpenMailModal}
                        ShowFormatToPrint={ShowFormatToPrint}
                        printhide={printhide}
                        reprint={false}
                    />
                }
                {
                    ShowRefundOfPaymentsModal &&
                    <RefundOfPaymentsModal
                        {...this.props}
                    />
                }


            </div >
        );
    }
}

export default RefundModal;